// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"30":"component---node-modules-shapeable-gatsby-theme-shapeable-src-components-app-tsx","227":"component---node-modules-shapeable-gatsby-theme-shapeable-src-pages-404-tsx"}[chunkId] + "-" + {"30":"1d1580b2858cf0b58355","227":"ceaf4ca8718460bd202d"}[chunkId] + ".js";
};